
import Cookies from 'js-cookie'
import { writable } from 'svelte/store'
import { User } from './models'
export { Context, isLoggedIn, currentUser, screenWidth, bodyWidth, isDesktop, notify, notificationInfo }

let isLoggedIn = writable(false)
let currentUser = writable({})
let notificationInfo = writable(null)
let screenWidth = writable(1000)
let bodyWidth = writable('80%')
let isDesktop = writable(true)

function notify(message, icon='prompt', duration=1600) {
  let info = {message: message, icon: icon, duration: duration}
  notificationInfo.set(info)
}

class Context {
  static data = {}
  static getToken() {
    return this.get('token') || localStorage.getItem('tksk') || Cookies.get('tksk') || ''
  }

  static setToken(token) {
    this.set('token', token)
    localStorage.setItem('tksk', token)
    Cookies.set('tksk', token, {expires: 14})
  }

  static preInit() {
    let token = localStorage.getItem('tksk') || Cookies.get('tksk')
    if (token && token != 'undefine') {
      isLoggedIn.set(true)
      this.set('token', token)
    }
  }

  static async init() {
    let token = localStorage.getItem('tksk') || Cookies.get('tksk')
    if (token && token != 'undefined') {
      let user = await User.auth(token)
      if (user) { 
        this.setUser(user) 
      } else {
        this.user = null 
        isLoggedIn.set(false)
      }
    } else {
      this.unsetUser()
    }
  }

  static async reloadUser() {
    let user = await User.get()
    if (user) currentUser.set(user)
  }

  static set(k, v) { this.data[k] = v }
  static get(k, d=null) { return k in this.data ? this.data[k] : d }
  static remove(k) { delete this.data[k] }

  static setUser(user) {
    if (!user) return
    this.setToken(user.token)
    isLoggedIn.set(true)
    currentUser.set(user)
  }

  static unsetUser() {
    this.user = null 
    this.remove('token')
    Cookies.remove('tksk')
    localStorage.removeItem('tksk')
    isLoggedIn.set(false)
  }
}